export default __webpack_public_path__ + "static/media/myRewards4.21090a85.png";